import { render } from "./App.vue?vue&type=template&id=9584ba66"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9584ba66&lang=scss"

import exportComponent from "/Users/peterdevos/Apps/scania_guess_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__